<business-header [isAuthenticated]="isAuthenticated"></business-header>
<router-outlet></router-outlet>
<business-footer></business-footer>
